var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0195,
    cy: 18.2167,
    r: 17.5351,
    fill: "#D1FFE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9462 16.9915H10.2656M24.9462 19.0305V16.0128C24.9462 14.6425 24.9462 13.9573 24.6795 13.4339C24.4449 12.9735 24.0706 12.5992 23.6102 12.3647C23.0868 12.098 22.4017 12.098 21.0314 12.098H14.1804C12.8101 12.098 12.125 12.098 11.6016 12.3647C11.1412 12.5992 10.7669 12.9735 10.5323 13.4339C10.2656 13.9573 10.2656 14.6425 10.2656 16.0128V22.8637C10.2656 24.234 10.2656 24.9192 10.5323 25.4426C10.7669 25.903 11.1412 26.2773 11.6016 26.5118C12.125 26.7785 12.8101 26.7785 14.1804 26.7785H17.6059M20.8682 10.4668V13.7291M14.3436 10.4668V13.7291M19.6449 24.3318L21.276 25.9629L24.9462 22.2928",
    stroke: "#319759",
    strokeWidth: 1.63117,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.16ad6aa56141d55f39219e55bf34c825.svg";
export { ForwardRef as ReactComponent };